import { NativeStackHeaderProps, Stack } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { WebView } from 'react-native-webview';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import theme from 'shared/styles/theme';
import { webViewAdditionalProps } from 'shared/utils/webView/webViewAdditionalProps';

const Topics = () => {
  const { bottom } = useSafeAreaInsets();
  const { t: translatedText } = useTranslation('myVaro', {
    keyPrefix: 'help',
  });
  return (
    <View style={[styles.webview, { paddingBottom: bottom }]}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          title: translatedText('title'),
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
        }}
      />
      <WebView
        {...webViewAdditionalProps}
        source={{ uri: 'https://support.varomoney.com/hc/en-us' }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  webview: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default Topics;
